import type { Patrol } from '@local/common-lib';
import { Box } from '@mui/material';
import type { FeatureCollection, Point } from 'geojson';
import type { LngLat } from 'mapbox-gl';
import type { FC } from 'react';
import { IncidentsLayer } from '../../components/incidents/layer.js';
import { MapComponent } from '../../components/map/component.js';
import { MapStyles } from '../../components/map/map-styles.js';
import type { Bounds } from '../../utils/geo.js';

interface Props {
  bounds: Bounds | undefined;
  onClick?: (latLng: LngLat, props: Record<string, unknown>) => void;
  onUnselect?: () => void;
  points: FeatureCollection<Point, Record<string, unknown>>;
  selected?: Patrol.Incident & { _instance: string; patrolId: string };
}

export const IncidentMapView: FC<Props> = ({
  bounds,
  onClick,
  onUnselect,
  points,
  selected: incident,
}) => (
  <Box
    sx={{
      '& .popup': {
        '& .mapboxgl-popup-content': {
          padding: '16px',
        },
        color: 'black',
      },
      height: '100%',
      width: '100%',
    }}
  >
    <MapComponent bounds={bounds} mapStyle={MapStyles.DARK}>
      <IncidentsLayer
        onClick={onClick}
        onUnselect={onUnselect}
        points={points}
        selected={incident}
      />
    </MapComponent>
  </Box>
);
